import React, { useState, useEffect, useContext } from 'react';
import { useParams } from "react-router-dom";
import "./EditAddEmployee.css"
// import "../editEmployee/EditAddEmployee.css"
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import TextField from '@mui/material/TextField';
import { Tooltip } from "@mui/material";
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Button from '@mui/material/Button';
import personalInfo from "assets/images/resign.jpg";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import * as moment from "moment";
import { toast } from "react-toastify";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import Loader from "components/Loader";
// import config from "config/config";
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Paper from '@mui/material/Paper';

import Context from "context/context";
import {
  Dialog, DialogActions, DialogContent, DialogTitle, ButtonBase, RadioGroup, Radio,
  CircularProgress,
} from "@mui/material";
import {
  Modal,
  Checkbox,
  FormControlLabel,
} from "@mui/material";

import Typography from '@mui/material/Typography';
import submitResignationAPIs from 'apis/panel/SubmitResignation/submitResignation';
import swal from 'sweetalert';

const SubmitResignation = () => {
  const { dispatch } = useContext(Context);

  const { state } = useContext(Context);
  const [employeeResignStatus, setEmployeeResignStatus] = useState([]);
  const [roleCode] = useState(state.role.roleCode);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  let params = useParams();
  const employeeId = params.id;
  const [isSubmitModalOpen, setIsSubmitModalOpen] = useState(false);
  const [alternateEmail, setAlternateEmail] = useState(""); // State for alternate email
  const [alternateMobile, setAlternateMobile] = useState("");



  const [EmployeeId] = useState(sessionStorage.getItem('EmployeeID'))

  const [relName, setrelName] = useState();
  const [expanded, setExpanded] = useState(false);
  const [isEditMode, setIsEditMode] = useState(true);

  const [employeecode, setemployeecode] = useState('')
  // const [relationshipname, setrelationshipname] = useState('')
  const [dateOfBirth, setDateOfBirth] = useState('')

  const [selectedReason, setSelectedReason] = useState("");
    const [selectedAttrition, setSelectedAttrition] = useState("Voluntary");
  const [emailError, setEmailError] = useState(false); // State for email validation error
  const [mobileError, setMobileError] = useState(false);
  const steps = [
    "Resignation Submitted",
    "Manager Approval (level 1)",
    "Manager Approval (level 2)",
    "HR Approval",
    "Clearance Completed",
    "Final Approval"
  ];



  const isFormValid = alternateEmail && alternateMobile && isChecked && !emailError && !mobileError;
  const [open, setOpen] = useState(false);
  const [questions, setQuestions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [responses, setResponses] = useState({});
  const [selectedExitId, setSelectedExitId] = useState(null);
  const [exitReasons, setExitReasons] = useState([]);
  
  const isEditable = roleCode == "R001" || roleCode == "R011";

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const mobileRegex = /^[0-9]{10}$/;

  const [loader2, setLoader2] = useState(false)
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60%",
    maxHeight: "80vh",
    overflowY: "auto",
    bgcolor: "background.paper",
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
  };

  const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);

  const {getExitReasonsAPI,getResignStatusAPI,submitResignationAPI,
    withdrawResignationAPI,getInterviewQuestionAPI,submitInterviewResponseAPI} = submitResignationAPIs();

  useEffect(() => {
    // Enable submit only if all questions are answered
    const allAnswered = questions.every((q) => responses[q.exitInterviewQuestionsId]?.trim());
    setIsSubmitEnabled(allAnswered);
  }, [responses, questions]);


  useEffect(() => {

    fetchResignStatus();
    fetchExitReasons();

  }, [])

  const fetchExitReasons = async () => {
    try {
      

      const data = await getExitReasonsAPI() ;
     
      
      if (data.status === "Ok" && Array.isArray(data.reasons)) {
        setExitReasons(data.reasons); // Set reasons in state
      } else {
        console.error("Invalid API response:", data);
      }
    } catch (error) {
      console.error("Error fetching exit reasons:", error);
    }
  };

  const handleEmailChange = (e) => {
    const email = e.target.value;
    setAlternateEmail(email);

    // Validate email format
    if (emailRegex.test(email)) {
      setEmailError(false);
    } else {
      setEmailError(true);
    }
  };

  const handleMobileChange = (e) => {
    const mobile = e.target.value;
    setAlternateMobile(mobile);

    // Validate mobile number format
    if (mobileRegex.test(mobile)) {
      setMobileError(false);
    } else {
      setMobileError(true);
    }
  };


  const fetchResignStatus = async () => {
    try {
     
      const data = await getResignStatusAPI();

      
      if (data.status === "Ok" && Array.isArray(data.employeeResignStatus)) {
       
        const resignCount = data.resignCount;
      const resignationData = data.employeeResignStatus.map((status) => ({
          resignCount: resignCount,
          resignStatus: status.resignStatus,
          resignationSubmitDate: moment.utc(status.resignationSubmitDate).isValid()
          ? moment.utc(status.resignationSubmitDate).format("DD/MM/YYYY")
          : "--",
          exitReason: status.exitReason,
          altPhone: status.altPhone,
          altEmail: status.altEmail,
          progressStatus: status.progressStatus,
          l2ApprovalStatus:status.l2ApprovalStatus,
          lastWorkingDay:moment.utc(status.lastWorkingDay).isValid()
          ? moment.utc(status.lastWorkingDay).format("DD/MM/YYYY")
          : "--",
                    employeeId: status.employeeId,
          employeeCode: status.employeeCode,
          firstName: status.firstName,
          exitId: status.exitId,
          attritionType:status.attritionType,
        }));

     
        setEmployeeResignStatus(resignationData);

      
      } else {
        console.error("Unexpected response format:", data);
      }
    } catch (error) {
    
      console.error("Error fetching resignation status:", error);
    } finally {
      
    }
  };



  const [errors, setErrors] = useState({});




  const handleClick = async () => {


    setLoader2(true);
    const validationErrors = {};

    if (!selectedReason) {
      validationErrors.selectedReason = true;
    }

    setErrors(validationErrors);
    if (Object.keys(validationErrors).length === 0) {
      setIsModalOpen(true);
    } else {
      console.log("Validation failed", validationErrors);
    }

    setLoader2(false);
  };


  const handleAccordionChange = (event, isExpanded) => {
    setExpanded(isExpanded);
    if (!isExpanded) {
      setIsEditMode(true);
    }
  };

  const maxDate = new Date();

  const handleOpen = () => setIsModalOpen(true);
  const handleClose = () => setIsModalOpen(false);

  const handleCheckboxChange = (e) => {
    setIsChecked(e.target.checked);
  };


  const handleConfirm = async () => {

   

      const confirmation = await swal({
                title: "Confirm",
                text: "Are you sure you want to proceed with the resignation process?",
                icon: "warning",
                buttons: {
                  cancel: {
                    text: "Reject",
                    value: false,
                    visible: true,
                    className: "swal-button-disagree",
                  },
                  confirm: {
                    text: "Accept",
                    value: true,
                    visible: true,
                    className: "swal-button-agree",
                  },
                },
                dangerMode: false,
              });
    if(confirmation){
       dispatch({ type: "SET_LOADING", payload: true });


    const employeeId = employeeResignStatus[0]?.employeeId;
    const lastWorkingDay = employeeResignStatus[0]?.lastWorkingDay
  ? moment(employeeResignStatus[0].lastWorkingDay, "DD/MM/YYYY").format("YYYY-MM-DD")
  : "";
    const body = {
      employeeId,
      altEmail: alternateEmail,
      altPhoneNumber: alternateMobile,
      exitReason: selectedReason,
      lastWorkingDay,
      attritionType:selectedAttrition,
    };

     try {
      
        const data = await submitResignationAPI(body);
        if (data.status === 'Ok') {
          toast.success("Resignation submitted successfully");
         
          // setIsSubmitModalOpen(false);
          setIsModalOpen(false);
          fetchResignStatus();
          dispatch({ type: "SET_LOADING", payload: false });
         
        } else {
          toast.error("Error: " + data.message || "Unknown error");
          dispatch({ type: "SET_LOADING", payload: false });
        }
      
    } catch (error) {
      toast.error("Error submitting resignation: " + error.message);
      
      dispatch({ type: "SET_LOADING", payload: false });
    }

    }
   

   
  };

 
  const handleCancel = () => {
    setIsSubmitModalOpen(false);
  };

  const handleWithdrawResignation = async () => {
   
    dispatch({ type: "SET_LOADING", payload: true });
  
    const exitId = employeeResignStatus[0]?.exitId;
    if (!exitId) {
      toast.error("Exit ID is missing.");
      return;
    }

    try {
      dispatch({ type: "SET_LOADING", payload: true });

      const data = await withdrawResignationAPI(exitId);

      if (data.status === "Ok") {
        toast.success("Resignation Withdrawn Successfully!");
        handleCancel();
        fetchResignStatus();
      } else {
        toast.error("No changes were made. Try again.");
      }
    } catch (error) {
     
      toast.error(`Error: ${error.message}`);
    } finally {
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const fetchInterviewQuestions = async (exitId) => {
    dispatch({ type: "SET_LOADING", payload: true });
    setSelectedExitId(exitId)

    setLoading(true);
    try {
      
      const data = await getInterviewQuestionAPI() ;
      if (data.status === "Ok" && Array.isArray(data.questions)) {
        setQuestions(data.questions);
      }
    } catch (error) {
      console.error("Error fetching questions:", error);
    } finally {
      setLoading(false);
      setOpen(true);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleResponseChange = (questionId, value) => {
    setResponses((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const getStepLabel = (progressStatus) => {
    switch (progressStatus) {
      case "Manager Approved":
        return "Manager Approval";
      case "HR Approved":
        return "HR Approval";
      case "Final Approved":
        return "Final Approval";
      case "Clearance Completed":
        return "Clearance Completed";
      case "Resignation Submitted":
        return "Resignation Submitted";
      default:
        return progressStatus; // Fallback for unknown statuses
    }
  };
  const handleSubmit = async () => {
    dispatch({ type: "SET_LOADING", payload: true });

    const questionsAndOptions = Object.entries(responses).map(([questionId, answer]) => ({
      questionId,
      answer,
    }));

    const requestBody = {
      exitId: selectedExitId,
      questionsAndOptions,
    };

    try {
     

      const data = await submitInterviewResponseAPI(requestBody);

      if (data.status === "Ok") {
        setOpen(false); // Close the modal after submission
        dispatch({ type: "SET_LOADING", payload: false });

      } else {
        throw new Error("Failed to save response");
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } catch (error) {
      console.error("Error submitting responses:", error);
      dispatch({ type: "SET_LOADING", payload: false });
    }
  };




  return (
    <div>
      <Loader loading={loader2} />
      <Accordion sx={{ mt: 2, boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px" }} onChange={handleAccordionChange}>
        <AccordionSummary
          expandIcon={<ArrowDropDownIcon className="Accordianicon" />}
          aria-controls="panel1-content"
          id="panel1-header"
          style={{ boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px", height: "70px" }}
        >
          <Box sx={{ pl: 3 }}> <img sx={{ pl: 3 }} className='personalInfo-logo' src={personalInfo} alt="info" /></Box>
          <Box className="acc-title" sx={{ pl: 3 }}>Submit/Withdraw Resignation</Box>
          <Box sx={{ ml: 45 }}>

          </Box>
        </AccordionSummary>
        <AccordionDetails>

          <>
            <Grid container spacing={2} sx={{ pl: 3, pr: 5, mt: 2 }} style={{ display: "flex", justifyContent: "space-between" }} >
              <Box className="subHeadingforinfos" sx={{ pl: 3 }}>Submit Resignation </Box>
              
            </Grid>

            <Grid container spacing={2} sx={{ pl: 4, pr: 5, mt: 2 }} >

              {/* withdrawal pending status  */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) => {
                  
                  if (resign.resignStatus === "Withdrawal pending") {
                    // Steps for "Withdrawal pending"
                    const stepsForPending = ["Withdraw Submitted", "Approval Pending"];

                    // Ensure the first step ("Withdraw Submitted") is completed by default
                    let currentStep = stepsForPending.indexOf(resign.progressStatus);

                    // Default to "Withdraw Submitted" if progressStatus is undefined or null
                    if (currentStep === -1) currentStep = 0;

                    const nextStep = currentStep + 1 < stepsForPending.length ? currentStep + 1 : null; // Ensure next step exists

                    return (
                      <Grid item xs={12} key={index}>
                        <Paper
                          elevation={3}
                          sx={{
                            p: 3,
                            borderRadius: '12px',
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                          }}
                        >
                          {/* Stepper for Withdrawal pending */}
                          <Stepper
                            activeStep={nextStep}
                            alternativeLabel
                            sx={{
                              '& .MuiStepLabel-root .Mui-completed': {
                                color: 'green',
                              },
                              '& .MuiStepLabel-root .Mui-active': {
                                color: '#3f51b5',
                              },
                              '& .MuiStepLabel-label': {
                                fontWeight: 'bold',
                              },
                            }}
                          >
                            {stepsForPending.map((label, idx) => (
                              <Step key={label} completed={idx < currentStep}>
                                <StepLabel>{label}</StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </Paper>
                      </Grid>
                    );
                  }

                  if (resign.resignStatus !== "No action") {
function getStepLabel(status) {
  switch (status) {
    case 'Resignation Submitted':
      return 'Resignation Submitted';
    case 'Manager Approved':
      return 'Manager Approval (Level 1)';
    case 'L2 Manager Approved':
      return 'Manager Approval (Level 2)';
    case 'HR Approved':
      return 'HR Approval';
    case 'Clearance Completed':
      return 'Clearance Completed'
    case 'Final Approved':
      return 'Final Approval';
    default:
      return status;
  }
}
                   

                    const currentStep = steps.findIndex(
                    
                      
                      (step) => step.toLowerCase() === getStepLabel(resign.progressStatus).toLowerCase()
                    );


                    const nextStep = currentStep + 1 < steps.length ? currentStep + 1 : currentStep;

                    return (
                      <Grid item xs={12} key={index}>
                        <Paper
                          elevation={3}
                          sx={{
                            p: 3,
                            borderRadius: '12px',
                            backgroundColor: '#f9f9f9',
                            boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                          }}
                        >
                          {/* Stepper */}
                          <Stepper
                            activeStep={nextStep}
                            alternativeLabel
                            sx={{
                              '& .MuiStepLabel-root .Mui-completed': {
      color: 'green !important', 
    },
                              '& .MuiStepLabel-root .Mui-active': {
                                color: '#3f51b5',
                              },
                              '& .MuiStepLabel-label': {
                                fontWeight: 'bold',
                              },
                            }}
                          >
                            {steps.map((label, idx) => (
                              <Step key={label} completed={idx <= currentStep}>
                                <StepLabel>{label}</StepLabel>
                              </Step>
                            ))}
                          </Stepper>
                        </Paper>
                      </Grid>
                    );
                  }


                  return null;
                })}

                 {/* withdrawal pending status  */}

                 {/* no action yet status  */}

                 {/* Resignation submission date */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "No action" ? (
                    <Grid item xs={12} sm={6} md={6} lg={6} key={index}>
                      <Box className="label">Resignation submission date</Box>
                      <LocalizationProvider fullWidth dateAdapter={AdapterDateFns}>
                        <DatePicker
                          sx={{ width: "100%" }}
                          id="dateOfBirth"
                          name="dateOfBirth"
                          value={new Date()}
                          readOnly
                          disabled
                          maxDate={maxDate}
                          slotProps={{
                            field: { clearable: true },
                          }}
                          format="dd/MM/yyyy"
                          renderInput={(params) => <TextField {...params} helperText={null} />}
                        />
                      </LocalizationProvider>
                      {errors.dateOfBirth && (
                        <div className="error-message">This field is mandatory.</div>
                      )}
                    </Grid>
                  ) : resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }} key={index}>
                      <Box className="editlabel">Resignation submission date</Box>
                      <Box className="editvalue">{moment(resign.resignationSubmitDate, "DD/MM/YYYY", true).isValid()
  ? moment(resign.resignationSubmitDate, "DD/MM/YYYY").format("DD/MM/YYYY")
  : "--"}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Resignation submission date */}

               {/* Employee id */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "No action" ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label" >Employee ID </Box>
                      <TextField id="firstName"
                        placeholder="Id Proof"
                        value={resign.employeeCode}
                        disabled={true}
                        variant="outlined"
                        fullWidth />
                    </Grid>
                  ) : resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel" >Employee ID</Box>
                      <Box className="editvalue">{resign.employeeCode}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Employee id */}

                 {/* Leaving reasons  */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "No action" ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        Reason for Leaving <span style={{ color: "red" }}>*</span>
                      </Box>
                      <FormControl fullWidth>
                        <Select
                          labelId="reason-label"
                          id="reason"
                          placeholder="Select Reason"
                          value={selectedReason}
                          displayEmpty
                          onChange={(e) => setSelectedReason(e.target.value)}
                          inputProps={{ "aria-label": "Without label" }}
                          style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                        >
                          <MenuItem value="">Select Reason</MenuItem>
                          {exitReasons.map((reason, index) => (
                            <MenuItem key={index} value={reason}>
                              {reason}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      {!selectedReason && <div className="error-message">This field is mandatory.</div>}
                    </Grid>
                  ) : resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel" >Reason for Leaving</Box>
                      <Box className="editvalue">{resign.exitReason}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Leaving reasons  */}

                 {/* Leaving reasons  */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "No action" ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label">
                        Attrition Type 
                      </Box>
                      <FormControl fullWidth>
                        <Select
                          labelId="reason-label"
                          id="reason"
                          placeholder="Select Attrition"
                          value={selectedAttrition} 
                          displayEmpty
                          onChange={(e) => setSelectedAttrition(e.target.value)}
                         inputProps={{ "aria-label": "Attrition Type" }}
                          style={{ border: "1.5px solid #B2D4F8", color: "grey" }}
                          disabled={true} 
                        >
                           <MenuItem value="Voluntary">Voluntary</MenuItem>
      <MenuItem value="Involuntary">Involuntary</MenuItem>
                        </Select>
                      </FormControl>
                      
                    </Grid>
                  ) : resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: 2 }}>
                      <Box className="editlabel" >Attrition Type</Box>
                      <Box className="editvalue">{resign.attritionType}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Leaving reasons  */}

                 {/* Last working day */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "No action" ? (
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                      <Box className="label" >Notice Period </Box>
                      <TextField id="firstName"
                        placeholder="Id Proof"
                        value="60 Days"
                        disabled={true}
                        variant="outlined"
                        fullWidth />
                    </Grid>
                  ) : resign.resignStatus === "Applied" ? (
                   <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: "30px" }}>
                      <Box className="editlabel">Last Working Date</Box>
                      <Box className="editvalue"> {moment(resign.lastWorkingDay, "DD/MM/YYYY", true).isValid()
  ? moment(resign.lastWorkingDay, "DD/MM/YYYY").format("DD/MM/YYYY")
  : "--"}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Last working day  */}

                 {/* Personal Phone  */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: "30px" }}>
                      <Box className="editlabel">Personal Email</Box>
                      <Box className="editvalue">{resign.altEmail}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Personal Phone  */}

                 {/* Alternate phone  */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: "30px" }}>
                      <Box className="editlabel">Alternate Phone Number</Box>
                      <Box className="editvalue">{resign.altPhone}</Box>
                    </Grid>
                  ) : null
                )}

                 {/* Alternate phone */}

                 {/* Feedback form  */}

              {employeeResignStatus &&
                employeeResignStatus.map((resign, index) =>
                  resign.resignStatus === "Applied" ? (
                    <Grid item xs={12} sm={4} md={4} lg={4} sx={{ mt: "30px" }} key={index}>
                      <ButtonBase
                        onClick={() => {
                          if (resign.progressStatus !== "HR Approved") {
                            toast.warning("Feedback can only be accessed after HR approval.");
                            return;
                          }
                          fetchInterviewQuestions(resign.exitId);
                        }}
                        sx={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "12px 16px",
                          backgroundColor: "#e3f2fd",
                          borderRadius: "8px",
                          border: "1px solid #2196f3",
                          color: "#1565c0",
                          fontWeight: "bold",
                          textTransform: "none",
                          transition: "all 0.3s ease-in-out",
                          opacity: resign.progressStatus !== "HR Approved" ? 0.5 : 1,
                          filter: resign.progressStatus !== "HR Approved" ? "blur(0.5px)" : "none",
                          pointerEvents: resign.progressStatus !== "HR Approved" ? "none" : "auto",
                          "&:hover": {
                            backgroundColor: "#bbdefb",
                          },
                        }}
                      >
                        Attend Feedback
                      </ButtonBase>
                    </Grid>
                  ) : null
                )}

                 {/* Feedback form  */}

            </Grid>
          </>

{/* next and withdraw option  */}

          {employeeResignStatus &&
            employeeResignStatus.map((resign, index) =>
              resign.resignStatus === "No action" ? (

                <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >

                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Tooltip title={resign.resignCount === 2 ? "You have reached your limit of resignation" : ""}>
                      <span>
                        <Button
                          className="saveButton"
                          onClick={handleClick}
                          disabled={resign.resignCount === 2}
                        >
                          Next
                        </Button>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              ) : resign.resignStatus === "Applied" ? (
                <Grid container spacing={1} sx={{ pl: 4, pr: 5, mt: 5, justifyContent: "center" }} >

                  <Grid item xs={12} sm={2} md={2} lg={2}>
                    <Tooltip title={resign.resignCount === 2 ? "You have reached your limit of Withdrawn" : ""}>
                      <span>


                        <Button className="saveButton" onClick={handleWithdrawResignation} disabled={
                          resign?.progressStatus === "Final Approved" ||
                          resign?.resignCount === 2 ||
                          resign?.progressStatus === "Clearance Completed"
                        } sx={{
                          minWidth: "100px",
                          width: "100%",
                          opacity: (resign?.progressStatus === "Final Approved" ||
                            resign?.resignCount === 2 ||
                            resign?.progressStatus === "Clearance Completed") ? 0.5 : 1,
                          pointerEvents: (resign?.progressStatus === "Final Approved" ||
                            resign?.resignCount === 2 ||
                            resign?.progressStatus === "Clearance Completed") ? "none" : "auto"
                        }}>Withdraw</Button>
                      </span>
                    </Tooltip>
                  </Grid>
                </Grid>
              ) : null
            )}

{/* next and withdraw option  */}


        </AccordionDetails>
      </Accordion>


      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "16px",
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: "bold",
            color: "#1565c0",
            textAlign: "center",
            fontSize: "1.5rem",
            borderBottom: "1px solid #e0e0e0",
            paddingBottom: "12px",
          }}
        >
          Exit Interview Feedback
        </DialogTitle>

        <DialogContent
          dividers
          sx={{
            backgroundColor: "#f9f9f9",
            padding: "16px",
            maxHeight: "60vh",
            overflowY: "auto",
          }}
        >
          {loading ? (
            <Grid container justifyContent="center">
              <CircularProgress />
            </Grid>
          ) : (
            questions.map((question) => (
              <Grid
                container
                spacing={2}
                key={question.exitInterviewQuestionsId}
                sx={{
                  mb: 2,
                  padding: "12px",
                  borderRadius: "8px",
                  backgroundColor: "#fff",
                  boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Grid item xs={12}>
                  <strong style={{ fontSize: "1rem", color: "#333" }}>{question.questions}</strong>
                </Grid>
                <Grid item xs={12}>
  {Array.isArray(question.options) && question.options.includes("Null") ? (
    <TextField
      fullWidth
      label="Your response"
      variant="outlined"
      value={responses[question.exitInterviewQuestionsId] || ""}
      onChange={(e) =>
        handleResponseChange(question.exitInterviewQuestionsId, e.target.value)
      }
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
          backgroundColor: "#fff",
        },
      }}
    />
  ) : (
    <RadioGroup
      value={responses[question.exitInterviewQuestionsId] || ""}
      onChange={(e) =>
        handleResponseChange(question.exitInterviewQuestionsId, e.target.value)
      }
    >
      {Array.isArray(question.options) ? (
        question.options.map((option) => (
          <FormControlLabel
            key={option}
            value={option}
            control={<Radio sx={{ color: "#1565c0" }} />}
            label={option}
            sx={{ marginLeft: "8px" }}
          />
        ))
      ) : (
        <TextField
          fullWidth
          label="Your response"
          variant="outlined"
          value={responses[question.exitInterviewQuestionsId] || ""}
          onChange={(e) =>
            handleResponseChange(question.exitInterviewQuestionsId, e.target.value)
          }
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "8px",
              backgroundColor: "#fff",
            },
          }}
        />
      )}
    </RadioGroup>
  )}
</Grid>
              </Grid>
            ))
          )}
        </DialogContent>

        <DialogActions
          sx={{
            padding: "16px",
            borderTop: "1px solid #e0e0e0",
            backgroundColor: "#fafafa",
          }}
        >
          <Button
            onClick={handleCloseModal}
            sx={{
              color: "#555",
              textTransform: "none",
              fontSize: "0.95rem",
              "&:hover": {
                backgroundColor: "#e0e0e0",
              },
            }}
          >
            Close
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!isSubmitEnabled}
            onClick={handleSubmit}
            sx={{
              textTransform: "none",
              fontSize: "0.95rem",
              fontWeight: "bold",
              padding: "6px 20px",
              borderRadius: "8px",
              backgroundColor: isSubmitEnabled ? "#1565c0" : "#b0bec5",
              "&:hover": {
                backgroundColor: isSubmitEnabled ? "#0d47a1" : "#b0bec5",
              },
            }}
          >
            Submit
          </Button>
        </DialogActions>
      </Dialog>


      <Modal open={isModalOpen} onClose={handleClose}>
        <Box sx={style}>
          <Typography
            variant="h5"
            component="h2"
            sx={{
              mb: 2,
              fontWeight: "bold",
              fontSize: "1.8rem",
              color: "#0070E9",
            }}
          >
            Consent & Acknowledgment
          </Typography>

          {/* Modal Content */}
          <Typography variant="body1" sx={{ mb: 2 }}>
            I, {employeeResignStatus[0]?.firstName},  hereby confirm the following regarding my voluntary resignation from Value Health Inc:
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Serving Notice Period:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Employees must provide two months advance written notice of resignation, as per the employment agreement. Failure to do so may result in ineligibility for rehire and recovery of payment for the shortfall in the notice period based on the latest compensation.          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Leaves during Notice Period:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Employees must serve the notice period without leave, unless approved by the Department Head, HR, and India Head. If leave is granted, the notice period will be extended accordingly, excluding company-declared holidays.
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Exit Interviews:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            CVHS schedules exit interviews upon resignation/termination to discuss benefits, debt repayment, company property return, and gather feedback for improvement.
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Return of Company Property:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            All company property (e.g., laptops, phones, access cards) must be returned upon termination. Employees are liable for lost or damaged items, and costs may be deducted from their final paycheck.
          </Typography>

          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 1 }}>
            Full and Final Settlement:
          </Typography>
          <Typography variant="body2" sx={{ mb: 2 }}>
            Dues will be settled in the next payroll cycle, after clearing all obligations in the Clearance Checklist. Provident Fund will be processed separately once the required forms are received.          </Typography>



          <Typography variant="body2" sx={{ mb: 2 }}>
            By agreeing, I acknowledge that I have read, understood, and agreed to the terms outlined above. I confirm that my decision to resign is voluntary and that I am aware of the next steps in the employee separation process.
          </Typography>

          <Grid container spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Box className="label">Personal Email<span style={{ color: "red" }}>*</span></Box>
              <TextField
                id="alternateEmail"
                placeholder="Enter personal email"
                value={alternateEmail}
                onChange={handleEmailChange}
                variant="outlined"
                fullWidth
                error={emailError} // Show error if email is invalid
                helperText={emailError ? 'Invalid email format' : ''}
              />
            </Grid>

            {/* Alternate Mobile Number Input */}
            <Grid item xs={12} sm={6} md={6} lg={6}>
              <Box className="label">Mobile Number<span style={{ color: "red" }}>*</span></Box>
              <TextField
                id="alternateMobile"
                placeholder="Enter mobile number"
                value={alternateMobile}
                onChange={handleMobileChange}
                variant="outlined"
                fullWidth
                error={mobileError} // Show error if mobile is invalid
                helperText={mobileError ? 'Invalid mobile number format' : ''}
              />
            </Grid>
          </Grid>

          {/* Checkbox */}
          <FormControlLabel
            control={
              <Checkbox
                checked={isChecked}
                onChange={handleCheckboxChange}
                sx={{
                  color: "primary.main",
                  '&.Mui-checked': {
                    color: "secondary.main",
                  },
                }}
              />
            }
            label={
              <Typography sx={{ color: "blue", fontWeight: "bold" }}>
                I agree to the above terms
              </Typography>
            }
          />


          <Grid container justifyContent="flex-end" spacing={2} sx={{ mt: 2 }}>
            <Grid item>
              <Button
                variant="outlined"
                color="secondary"
                onClick={handleClose}
                sx={{
                  border: "1px solid #FE602F",
                  color: "#FE602F",
                  fontFamily: "Inter",
                  backgroundColor: "transparent",
                  '&:hover': {
                    backgroundColor: "#FE602F",
                    color: " #FFFFFF",
                  },
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                onClick={handleConfirm}
                disabled={!isFormValid}
                sx={{
                  backgroundColor: "#FE602F",
                  color: "#FFFFFF",
                  fontFamily: "Inter",
                  '&:hover': {
                    backgroundColor: "#D94C1E",
                    color: "#FFFFFF",
                  },
                  '&:disabled': {
                    backgroundColor: 'gray',
                    color: 'lightgray',
                  },
                }}
              >
                Submit
              </Button>


            </Grid>
          </Grid>
        </Box>
      </Modal>

     


    </div>

  )
}

export default SubmitResignation